import { createContext } from "react";

export const BypassProtectedRoutesContext = createContext(false);
